import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openSnackBar } from '../../redux/actions/snackbar.actions';
import { getApiUrl } from '../../utils/apiUrls';
import { apiErrorHandler } from '../../utils/errorHandler';
import { stringPurifer } from '../../utils/helperFn';
import instance from '../../utils/axios';
import { MenuItem, Select } from '@mui/material';

const PersonalDetailsForm = ({ t, user }) => {
    const initial_val = {
        candidateAge: {
            value: '',
            isRequired: true,
            msg: null
        },
        gender: {
            value: '',
            isRequired: true,
            msg: null,
            inpVal: '',
            inpMsg: null,
        },
        ethnicity: {
            value: '',
            isRequired: true,
            msg: null,
            inpVal: '',
            inpMsg: null,
        },
        educationalBackground: {
            value: '',
            isRequired: true,
            msg: null,
            inpVal: '',
            inpMsg: null,
        },
        workExperience: {
            value: '',
            isRequired: true,
            msg: null
        },
        location: {
            value: '',
            isRequired: true,
            msg: null
        },
        levelWithOrganization: {
            value: '',
            isRequired: true,
            msg: null
        },
        jobFunction: {
            value: '',
            isRequired: true,
            msg: null,
            inpVal: '',
            inpMsg: null,
        },
        industry: {
            value: '',
            isRequired: true,
            msg: null,
            inpVal: '',
            inpMsg: null,
        },
    };

    const selectOptionData = React.useMemo(() => {
        return {
            candidateAge: [
                { label: t("cand_age_under_18"), value: "Under 18" },
                { label: t("cand_age_18_24"), value: "18-24" },
                { label: t("cand_age_25_34"), value: "25-34" },
                { label: t("cand_age_35_44"), value: "35-44" },
                { label: t("cand_age_45_54"), value: "45-54" },
                { label: t("cand_age_55_64"), value: "55-64" },
                { label: t("cand_age_65_and_above"), value: "65 and above" },
            ],
            gender: [
                { label: t("cand_gender_male"), value: "Male" },
                { label: t("cand_gender_female"), value: "Female" },
                { label: t("cand_gender_non_binary"), value: "Non-binary" },
                { label: t("cand_gender_prefer_not_to_say"), value: "Prefer not to say" },
                { label: t("cand_gender_other"), value: "Other" },
            ],
            ethnicity: [
                { label: t("cand_eth_asian"), value: "Asian" },
                { label: t("cand_eth_black"), value: "Black" },
                { label: t("cand_eth_hispanic"), value: "Hispanic" },
                { label: t("cand_eth_native_american"), value: "Native American" },
                { label: t("cand_eth_white"), value: "White" },
                { label: t("cand_eth_two_or_more_races"), value: "Two or more races" },
                { label: t("cand_eth_prefer_not_to_say"), value: "Prefer not to say" },
                { label: t("cand_eth_other"), value: "Other" },
            ],
            educationalBackground: [
                { label: t("cand_edu_back_high_school_diploma_or_equivalent"), value: "High School Diploma or equivalent" },
                { label: t("cand_edu_back_associates_degree"), value: "Associate's Degree" },
                { label: t("cand_edu_back_bachelors_degree"), value: "Bachelor's Degree" },
                { label: t("cand_edu_back_masters_degree"), value: "Master's Degree" },
                { label: t("cand_edu_back_doctorate"), value: "Doctorate" },
                { label: t("cand_edu_back_professional_certification"), value: "Professional Certification" },
                { label: t("cand_edu_back_other"), value: "Other" },
            ],
            workExperience: [
                { label: t("cand_work_exp_less_than_1_year"), value: "Less than 1 year" },
                { label: t("cand_work_exp_1_3_years"), value: "1-3 years" },
                { label: t("cand_work_exp_4_6_years"), value: "4-6 years" },
                { label: t("cand_work_exp_7_10_years"), value: "7-10 years" },
                { label: t("cand_work_exp_11_15_years"), value: "11-15 years" },
                { label: t("cand_work_exp_16_20_years"), value: "16-20 years" },
                { label: t("cand_work_exp_more_than_20_years"), value: "More than 20 years" },
            ],
            location: [
                { label: t("cand_loc_afghanistan"), value: "Afghanistan" },
                { label: t("cand_loc_aland_islands"), value: "Åland Islands" },
                { label: t("cand_loc_albania"), value: "Albania" },
                { label: t("cand_loc_algeria"), value: "Algeria" },
                { label: t("cand_loc_american_samoa"), value: "American Samoa" },
                { label: t("cand_loc_andorra"), value: "AndorrA" },
                { label: t("cand_loc_angola"), value: "Angola" },
                { label: t("cand_loc_anguilla"), value: "Anguilla" },
                { label: t("cand_loc_antarctica"), value: "Antarctica" },
                { label: t("cand_loc_antigua_and_barbuda"), value: "Antigua and Barbuda" },
                { label: t("cand_loc_argentina"), value: "Argentina" },
                { label: t("cand_loc_armenia"), value: "Armenia" },
                { label: t("cand_loc_aruba"), value: "Aruba" },
                { label: t("cand_loc_australia"), value: "Australia" },
                { label: t("cand_loc_austria"), value: "Austria" },
                { label: t("cand_loc_azerbaijan"), value: "Azerbaijan" },
                { label: t("cand_loc_bahamas"), value: "Bahamas" },
                { label: t("cand_loc_bahrain"), value: "Bahrain" },
                { label: t("cand_loc_bangladesh"), value: "Bangladesh" },
                { label: t("cand_loc_barbados"), value: "Barbados" },
                { label: t("cand_loc_belarus"), value: "Belarus" },
                { label: t("cand_loc_belgium"), value: "Belgium" },
                { label: t("cand_loc_belize"), value: "Belize" },
                { label: t("cand_loc_benin"), value: "Benin" },
                { label: t("cand_loc_bermuda"), value: "Bermuda" },
                { label: t("cand_loc_bhutan"), value: "Bhutan" },
                { label: t("cand_loc_bolivia"), value: "Bolivia" },
                { label: t("cand_loc_bosnia_and_herzegovina"), value: "Bosnia and Herzegovina" },
                { label: t("cand_loc_botswana"), value: "Botswana" },
                { label: t("cand_loc_bouvet_island"), value: "Bouvet Island" },
                { label: t("cand_loc_brazil"), value: "Brazil" },
                { label: t("cand_loc_british_indian_ocean_territory"), value: "British Indian Ocean Territory" },
                { label: t("cand_loc_brunei_darussalam"), value: "Brunei Darussalam" },
                { label: t("cand_loc_bulgaria"), value: "Bulgaria" },
                { label: t("cand_loc_burkina_faso"), value: "Burkina Faso" },
                { label: t("cand_loc_burundi"), value: "Burundi" },
                { label: t("cand_loc_cambodia"), value: "Cambodia" },
                { label: t("cand_loc_cameroon"), value: "Cameroon" },
                { label: t("cand_loc_canada"), value: "Canada" },
                { label: t("cand_loc_cape_verde"), value: "Cape Verde" },
                { label: t("cand_loc_cayman_islands"), value: "Cayman Islands" },
                { label: t("cand_loc_central_african_republic"), value: "Central African Republic" },
                { label: t("cand_loc_chad"), value: "Chad" },
                { label: t("cand_loc_chile"), value: "Chile" },
                { label: t("cand_loc_china"), value: "China" },
                { label: t("cand_loc_christmas_island"), value: "Christmas Island" },
                { label: t("cand_loc_cocos_keeling_islands"), value: "Cocos (Keeling) Islands" },
                { label: t("cand_loc_colombia"), value: "Colombia" },
                { label: t("cand_loc_comoros"), value: "Comoros" },
                { label: t("cand_loc_congo"), value: "Congo" },
                { label: t("cand_loc_congo_democratic_republic"), value: "Congo, The Democratic Republic of the" },
                { label: t("cand_loc_cook_islands"), value: "Cook Islands" },
                { label: t("cand_loc_costa_rica"), value: "Costa Rica" },
                { label: t("cand_loc_cote_divoire"), value: "Cote D'Ivoire" },
                { label: t("cand_loc_croatia"), value: "Croatia" },
                { label: t("cand_loc_cuba"), value: "Cuba" },
                { label: t("cand_loc_cyprus"), value: "Cyprus" },
                { label: t("cand_loc_czech_republic"), value: "Czech Republic" },
                { label: t("cand_loc_denmark"), value: "Denmark" },
                { label: t("cand_loc_djibouti"), value: "Djibouti" },
                { label: t("cand_loc_dominica"), value: "Dominica" },
                { label: t("cand_loc_dominican_republic"), value: "Dominican Republic" },
                { label: t("cand_loc_ecuador"), value: "Ecuador" },
                { label: t("cand_loc_egypt"), value: "Egypt" },
                { label: t("cand_loc_el_salvador"), value: "El Salvador" },
                { label: t("cand_loc_equatorial_guinea"), value: "Equatorial Guinea" },
                { label: t("cand_loc_eritrea"), value: "Eritrea" },
                { label: t("cand_loc_estonia"), value: "Estonia" },
                { label: t("cand_loc_ethiopia"), value: "Ethiopia" },
                { label: t("cand_loc_falkland_islands"), value: "Falkland Islands (Malvinas)" },
                { label: t("cand_loc_faroe_islands"), value: "Faroe Islands" },
                { label: t("cand_loc_fiji"), value: "Fiji" },
                { label: t("cand_loc_finland"), value: "Finland" },
                { label: t("cand_loc_france"), value: "France" },
                { label: t("cand_loc_french_guiana"), value: "French Guiana" },
                { label: t("cand_loc_french_polynesia"), value: "French Polynesia" },
                { label: t("cand_loc_french_southern_territories"), value: "French Southern Territories" },
                { label: t("cand_loc_gabon"), value: "Gabon" },
                { label: t("cand_loc_gambia"), value: "Gambia" },
                { label: t("cand_loc_georgia"), value: "Georgia" },
                { label: t("cand_loc_germany"), value: "Germany" },
                { label: t("cand_loc_ghana"), value: "Ghana" },
                { label: t("cand_loc_gibraltar"), value: "Gibraltar" },
                { label: t("cand_loc_greece"), value: "Greece" },
                { label: t("cand_loc_greenland"), value: "Greenland" },
                { label: t("cand_loc_grenada"), value: "Grenada" },
                { label: t("cand_loc_guadeloupe"), value: "Guadeloupe" },
                { label: t("cand_loc_guam"), value: "Guam" },
                { label: t("cand_loc_guatemala"), value: "Guatemala" },
                { label: t("cand_loc_guernsey"), value: "Guernsey" },
                { label: t("cand_loc_guinea"), value: "Guinea" },
                { label: t("cand_loc_guinea_bissau"), value: "Guinea-Bissau" },
                { label: t("cand_loc_guyana"), value: "Guyana" },
                { label: t("cand_loc_haiti"), value: "Haiti" },
                { label: t("cand_loc_heard_island_and_mcdonald_islands"), value: "Heard Island and Mcdonald Islands" },
                { label: t("cand_loc_holy_see"), value: "Holy See (Vatican City State)" },
                { label: t("cand_loc_honduras"), value: "Honduras" },
                { label: t("cand_loc_hong_kong"), value: "Hong Kong" },
                { label: t("cand_loc_hungary"), value: "Hungary" },
                { label: t("cand_loc_iceland"), value: "Iceland" },
                { label: t("cand_loc_india"), value: "India" },
                { label: t("cand_loc_indonesia"), value: "Indonesia" },
                { label: t("cand_loc_iran"), value: "Iran, Islamic Republic Of" },
                { label: t("cand_loc_iraq"), value: "Iraq" },
                { label: t("cand_loc_ireland"), value: "Ireland" },
                { label: t("cand_loc_isle_of_man"), value: "Isle of Man" },
                { label: t("cand_loc_israel"), value: "Israel" },
                { label: t("cand_loc_italy"), value: "Italy" },
                { label: t("cand_loc_jamaica"), value: "Jamaica" },
                { label: t("cand_loc_japan"), value: "Japan" },
                { label: t("cand_loc_jersey"), value: "Jersey" },
                { label: t("cand_loc_jordan"), value: "Jordan" },
                { label: t("cand_loc_kazakhstan"), value: "Kazakhstan" },
                { label: t("cand_loc_kenya"), value: "Kenya" },
                { label: t("cand_loc_kiribati"), value: "Kiribati" },
                { label: t("cand_loc_korea_north"), value: "Korea, Democratic People'S Republic of" },
                { label: t("cand_loc_korea_south"), value: "Korea, Republic of" },
                { label: t("cand_loc_kuwait"), value: "Kuwait" },
                { label: t("cand_loc_kyrgyzstan"), value: "Kyrgyzstan" },
                { label: t("cand_loc_lao"), value: "Lao People'S Democratic Republic" },
                { label: t("cand_loc_latvia"), value: "Latvia" },
                { label: t("cand_loc_lebanon"), value: "Lebanon" },
                { label: t("cand_loc_lesotho"), value: "Lesotho" },
                { label: t("cand_loc_liberia"), value: "Liberia" },
                { label: t("cand_loc_libya"), value: "Libyan Arab Jamahiriya" },
                { label: t("cand_loc_liechtenstein"), value: "Liechtenstein" },
                { label: t("cand_loc_lithuania"), value: "Lithuania" },
                { label: t("cand_loc_luxembourg"), value: "Luxembourg" },
                { label: t("cand_loc_macao"), value: "Macao" },
                { label: t("cand_loc_macedonia"), value: "Macedonia, The Former Yugoslav Republic of" },
                { label: t("cand_loc_madagascar"), value: "Madagascar" },
                { label: t("cand_loc_malawi"), value: "Malawi" },
                { label: t("cand_loc_malaysia"), value: "Malaysia" },
                { label: t("cand_loc_maldives"), value: "Maldives" },
                { label: t("cand_loc_mali"), value: "Mali" },
                { label: t("cand_loc_malta"), value: "Malta" },
                { label: t("cand_loc_marshall_islands"), value: "Marshall Islands" },
                { label: t("cand_loc_martinique"), value: "Martinique" },
                { label: t("cand_loc_mauritania"), value: "Mauritania" },
                { label: t("cand_loc_mauritius"), value: "Mauritius" },
                { label: t("cand_loc_mayotte"), value: "Mayotte" },
                { label: t("cand_loc_mexico"), value: "Mexico" },
                { label: t("cand_loc_micronesia"), value: "Micronesia, Federated States of" },
                { label: t("cand_loc_moldova"), value: "Moldova, Republic of" },
                { label: t("cand_loc_monaco"), value: "Monaco" },
                { label: t("cand_loc_mongolia"), value: "Mongolia" },
                { label: t("cand_loc_montserrat"), value: "Montserrat" },
                { label: t("cand_loc_morocco"), value: "Morocco" },
                { label: t("cand_loc_mozambique"), value: "Mozambique" },
                { label: t("cand_loc_myanmar"), value: "Myanmar" },
                { label: t("cand_loc_namibia"), value: "Namibia" },
                { label: t("cand_loc_nauru"), value: "Nauru" },
                { label: t("cand_loc_nepal"), value: "Nepal" },
                { label: t("cand_loc_netherlands"), value: "Netherlands" },
                { label: t("cand_loc_netherlands_antilles"), value: "Netherlands Antilles" },
                { label: t("cand_loc_new_caledonia"), value: "New Caledonia" },
                { label: t("cand_loc_new_zealand"), value: "New Zealand" },
                { label: t("cand_loc_nicaragua"), value: "Nicaragua" },
                { label: t("cand_loc_niger"), value: "Niger" },
                { label: t("cand_loc_nigeria"), value: "Nigeria" },
                { label: t("cand_loc_niue"), value: "Niue" },
                { label: t("cand_loc_norfolk_island"), value: "Norfolk Island" },
                { label: t("cand_loc_northern_mariana_islands"), value: "Northern Mariana Islands" },
                { label: t("cand_loc_norway"), value: "Norway" },
                { label: t("cand_loc_oman"), value: "Oman" },
                { label: t("cand_loc_pakistan"), value: "Pakistan" },
                { label: t("cand_loc_palau"), value: "Palau" },
                { label: t("cand_loc_palestinian_territory"), value: "Palestinian Territory, Occupied" },
                { label: t("cand_loc_panama"), value: "Panama" },
                { label: t("cand_loc_papua_new_guinea"), value: "Papua New Guinea" },
                { label: t("cand_loc_paraguay"), value: "Paraguay" },
                { label: t("cand_loc_peru"), value: "Peru" },
                { label: t("cand_loc_philippines"), value: "Philippines" },
                { label: t("cand_loc_pitcairn"), value: "Pitcairn" },
                { label: t("cand_loc_poland"), value: "Poland" },
                { label: t("cand_loc_portugal"), value: "Portugal" },
                { label: t("cand_loc_puerto_rico"), value: "Puerto Rico" },
                { label: t("cand_loc_qatar"), value: "Qatar" },
                { label: t("cand_loc_reunion"), value: "Reunion" },
                { label: t("cand_loc_romania"), value: "Romania" },
                { label: t("cand_loc_russian_federation"), value: "Russian Federation" },
                { label: t("cand_loc_rwanda"), value: "RWANDA" },
                { label: t("cand_loc_saint_helena"), value: "Saint Helena" },
                { label: t("cand_loc_saint_kitts_and_nevis"), value: "Saint Kitts and Nevis" },
                { label: t("cand_loc_saint_lucia"), value: "Saint Lucia" },
                { label: t("cand_loc_saint_pierre_and_miquelon"), value: "Saint Pierre and Miquelon" },
                { label: t("cand_loc_saint_vincent_and_the_grenadines"), value: "Saint Vincent and the Grenadines" },
                { label: t("cand_loc_samoa"), value: "Samoa" },
                { label: t("cand_loc_san_marino"), value: "San Marino" },
                { label: t("cand_loc_sao_tome_and_principe"), value: "Sao Tome and Principe" },
                { label: t("cand_loc_saudi_arabia"), value: "Saudi Arabia" },
                { label: t("cand_loc_senegal"), value: "Senegal" },
                { label: t("cand_loc_serbia_and_montenegro"), value: "Serbia and Montenegro" },
                { label: t("cand_loc_seychelles"), value: "Seychelles" },
                { label: t("cand_loc_sierra_leone"), value: "Sierra Leone" },
                { label: t("cand_loc_singapore"), value: "Singapore" },
                { label: t("cand_loc_slovakia"), value: "Slovakia" },
                { label: t("cand_loc_slovenia"), value: "Slovenia" },
                { label: t("cand_loc_solomon_islands"), value: "Solomon Islands" },
                { label: t("cand_loc_somalia"), value: "Somalia" },
                { label: t("cand_loc_south_africa"), value: "South Africa" },
                { label: t("cand_loc_south_georgia_and_sandwich_islands"), value: "South Georgia and the South Sandwich Islands" },
                { label: t("cand_loc_spain"), value: "Spain" },
                { label: t("cand_loc_sri_lanka"), value: "Sri Lanka" },
                { label: t("cand_loc_sudan"), value: "Sudan" },
                { label: t("cand_loc_suriname"), value: "Suriname" },
                { label: t("cand_loc_svalbard_and_jan_mayen"), value: "Svalbard and Jan Mayen" },
                { label: t("cand_loc_swaziland"), value: "Swaziland" },
                { label: t("cand_loc_sweden"), value: "Sweden" },
                { label: t("cand_loc_switzerland"), value: "Switzerland" },
                { label: t("cand_loc_syrian_arab_republic"), value: "Syrian Arab Republic" },
                { label: t("cand_loc_taiwan"), value: "Taiwan, Province of China" },
                { label: t("cand_loc_tajikistan"), value: "Tajikistan" },
                { label: t("cand_loc_tanzania"), value: "Tanzania, United Republic of" },
                { label: t("cand_loc_thailand"), value: "Thailand" },
                { label: t("cand_loc_timor_leste"), value: "Timor-Leste" },
                { label: t("cand_loc_togo"), value: "Togo" },
                { label: t("cand_loc_tokelau"), value: "Tokelau" },
                { label: t("cand_loc_tonga"), value: "Tonga" },
                { label: t("cand_loc_trinidad_and_tobago"), value: "Trinidad and Tobago" },
                { label: t("cand_loc_tunisia"), value: "Tunisia" },
                { label: t("cand_loc_turkey"), value: "Turkey" },
                { label: t("cand_loc_turkmenistan"), value: "Turkmenistan" },
                { label: t("cand_loc_turks_and_caicos_islands"), value: "Turks and Caicos Islands" },
                { label: t("cand_loc_tuvalu"), value: "Tuvalu" },
                { label: t("cand_loc_uganda"), value: "Uganda" },
                { label: t("cand_loc_ukraine"), value: "Ukraine" },
                { label: t("cand_loc_united_arab_emirates"), value: "United Arab Emirates" },
                { label: t("cand_loc_united_kingdom"), value: "United Kingdom" },
                { label: t("cand_loc_united_states"), value: "United States" },
                { label: t("cand_loc_united_states_minor_outlying_islands"), value: "United States Minor Outlying Islands" },
                { label: t("cand_loc_uruguay"), value: "Uruguay" },
                { label: t("cand_loc_uzbekistan"), value: "Uzbekistan" },
                { label: t("cand_loc_vanuatu"), value: "Vanuatu" },
                { label: t("cand_loc_venezuela"), value: "Venezuela" },
                { label: t("cand_loc_viet_nam"), value: "Viet Nam" },
                { label: t("cand_loc_virgin_islands_british"), value: "Virgin Islands, British" },
                { label: t("cand_loc_virgin_islands_us"), value: "Virgin Islands, U.S." },
                { label: t("cand_loc_wallis_and_futuna"), value: "Wallis and Futuna" },
                { label: t("cand_loc_western_sahara"), value: "Western Sahara" },
                { label: t("cand_loc_yemen"), value: "Yemen" },
                { label: t("cand_loc_zambia"), value: "Zambia" },
                { label: t("cand_loc_zimbabwe"), value: "Zimbabwe" },
            ],
            levelWithOrganization: [
                { label: t("cand_level_org_executive_c_suite"), value: "Executive/C-suite" },
                { label: t("cand_level_org_vice_president"), value: "Vice President" },
                { label: t("cand_level_org_director"), value: "Director" },
                { label: t("cand_level_org_manager"), value: "Manager" },
                { label: t("cand_level_org_senior_level"), value: "Senior-level" },
                { label: t("cand_level_org_mid_level"), value: "Mid-level" },
                { label: t("cand_level_org_entry_level"), value: "Entry-level" },
                { label: t("cand_level_org_intern"), value: "Intern" },
            ],
            jobFunction: [
                { label: t("cand_job_function_administration"), value: "Administration" },
                { label: t("cand_job_function_business_development"), value: "Business Development" },
                { label: t("cand_job_function_customer_service"), value: "Customer Service" },
                { label: t("cand_job_function_engineering"), value: "Engineering" },
                { label: t("cand_job_function_finance"), value: "Finance" },
                { label: t("cand_job_function_human_resources"), value: "Human Resources" },
                { label: t("cand_job_function_information_technology"), value: "Information Technology" },
                { label: t("cand_job_function_legal"), value: "Legal" },
                { label: t("cand_job_function_marketing"), value: "Marketing" },
                { label: t("cand_job_function_operations"), value: "Operations" },
                { label: t("cand_job_function_product_management"), value: "Product Management" },
                { label: t("cand_job_function_project_management"), value: "Project Management" },
                { label: t("cand_job_function_research_and_development"), value: "Research and Development" },
                { label: t("cand_job_function_sales"), value: "Sales" },
                { label: t("cand_job_function_supply_chain_logistics"), value: "Supply Chain/Logistics" },
                { label: t("cand_job_function_other"), value: "Other" },
            ],
            industry: [
                { label: t("cand_industry_technology"), value: "Technology" },
                { label: t("cand_industry_finance"), value: "Finance" },
                { label: t("cand_industry_healthcare"), value: "Healthcare" },
                { label: t("cand_industry_education"), value: "Education" },
                { label: t("cand_industry_manufacturing"), value: "Manufacturing" },
                { label: t("cand_industry_retail"), value: "Retail" },
                { label: t("cand_industry_government"), value: "Government" },
                { label: t("cand_industry_non_profit"), value: "Non-profit" },
                { label: t("cand_industry_telecommunications"), value: "Telecommunications" },
                { label: t("cand_industry_energy"), value: "Energy" },
                { label: t("cand_industry_transportation"), value: "Transportation" },
                { label: t("cand_industry_hospitality"), value: "Hospitality" },
                { label: t("cand_industry_real_estate"), value: "Real Estate" },
                { label: t("cand_industry_media_and_entertainment"), value: "Media and Entertainment" },
                { label: t("cand_industry_other"), value: "Other" },
            ],
        }
    }, [t]);
    const [candidateProfileId, setCandidateProfileId] = React.useState(null);
    
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = React.useState(false);

    const [formVal, setFormVal] = React.useState(initial_val);

    React.useEffect(() => {
        getProfileData();
    }, [])

    const getProfileData = async () => {
        try {
            const res = await instance.get(`${getApiUrl("getCandidateProfileData")}`)
        
            if(res.data) {
                setFormVal(prevState => {
                    const currState = JSON.parse(JSON.stringify(prevState));
    
                    for(let key in currState) {
                        const optionExists = selectOptionData[key]?.some(option => {
                            const optionValue = typeof option === 'string' ? option : option.value;
                            return optionValue === res.data[key];
                        });
                        
                        if(optionExists) {
                            currState[key].value = res.data[key];
                        } else if(res.data[key] === null) {
                            currState[key].value = '';
                        } else {
                            currState[key].value = "Other";
                            currState[key].inpVal = res.data[key];
                        }
                    }
    
                    return currState
                });
                setCandidateProfileId(res.data.candidateProfileId);
            }
        } catch (error) {
            const errObj = apiErrorHandler(error);

            dispatch(openSnackBar({
                msg: t(errObj.statusText),
                type: 'error'
            }))
        }
    }

    const handleFieldChange = (e, fieldName) => {
        setFormVal({
            ...formVal,
            [fieldName]: {
                ...formVal[fieldName],
                inpVal: e.target.value,
                inpMsg: null,
            }
        })
    }

    const handleValidation = () => {
        let currentFormVal = JSON.parse(JSON.stringify(formVal));
        let isValid = true;

        for(let key in currentFormVal) {
            if(!currentFormVal[key].value) {
                currentFormVal[key].msg = t('field_required');
                isValid = false;
            } else if(currentFormVal[key].value === "Other") {
                if(!currentFormVal[key].inpVal) {
                    currentFormVal[key].inpMsg = t('field_required');
                    isValid = false;
                } else if(currentFormVal[key].inpVal?.length > 100) {
                    isValid = false;
                    currentFormVal[key].inpMsg = t('error_text_must_not_exceed_100_characters');
                }
            }
        }

        setFormVal(currentFormVal)
        return isValid;
    }

    const handleFormSubmit = async (e) => {
        try {
            e.preventDefault();
            if(handleValidation()) {
                setIsLoading(true);

                const dataToSend = {};

                for(let key in formVal) {
                    const filterData = stringPurifer(formVal[key].value === "Other" ? formVal[key].inpVal : formVal[key].value)
                    dataToSend[key] = filterData
                }

                const res = await instance.post(`${getApiUrl("saveAndUpdateCandidateProfileData")}${candidateProfileId ? `?candidateProfileId=${candidateProfileId}` : ''}`, dataToSend);
                if(res.data) {
                    setIsLoading(false);
                    if(res.data?.id) setCandidateProfileId(res.data.id)
                    dispatch(openSnackBar({
                        msg: t("profile_details_saved_successfully"),
                        type: "success"
                    }))
                }
            }
        } catch (error) {
            setIsLoading(false);
            const errObj = apiErrorHandler(error);

            dispatch(openSnackBar({
                msg: t(errObj.statusText),
                type: 'error'
            }))
        }
    }

    const handleSelectChange = (event, fieldName) => {
        const { value } = event.target;
        const options = selectOptionData[fieldName] || [];
        const selectedOption = options.find(option =>
            typeof option === 'string' ? option === value : option?.value === value
        );
        const selectedValue = typeof selectedOption === 'string'
            ? selectedOption
            : selectedOption?.value || value;

        setFormVal(prevState => ({
            ...prevState,
            [fieldName]:  {
                ...prevState[fieldName],
                value: selectedValue,
                msg: null,
                ...(prevState[fieldName].value === "Other" ? { inpVal: '', inpMsg: null } : {})
            },
        }))
    }

    const loadSelectOptions = (fieldName) => {
        return selectOptionData[fieldName]?.map(option => {
            const optionValue = typeof option === 'string' ? option : option.value;
            const optionLabel = typeof option === 'string' ? option : option.label;
            
            return (
                <MenuItem value={optionValue} key={fieldName + "-" + optionValue} className="d-flex align-items-center fw-medium cm-sm-txt text-blue-800">
                    <span>{optionLabel}</span>
                </MenuItem>
            );
        })
    }

    return(
        <form onSubmit={handleFormSubmit} className="cm-profile-form cm-reset-pass-form">
            <div className="row">
                <div className="col-lg-6 mt-3">
                    <div className="form-group">
                        <label htmlFor="candidateAge" className='pb-2 text-blue-gray-700 cm-xs-txt pb-2 fw-medium d-block'>{t("age")} <span className='text-danger'>*</span></label>
                        <div className="position-relative">
                            <Select
                                autoFocus={false}
                                labelId="candidateAgeLabel"
                                id="candidateAge"
                                displayEmpty={true}
                                value={formVal.candidateAge.value}
                                onChange={(e) => handleSelectChange(e, 'candidateAge') }
                                fullWidth={true}
                                className="bg-white cm-sm-txt fw-medium text-blue-800 cm-select-field"
                                MenuProps={{
                                    className: "cm-select-modal"
                                }}
                            >
                                {loadSelectOptions("candidateAge")}
                            </Select>
                            <FontAwesomeIcon icon={regular("chevron-down")} className="cm-select-arrow cm-sm-txt text-blue-800 position-absolute" />
                        </div>
                        {formVal.candidateAge.msg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.candidateAge.msg}</span>}
                    </div>
                </div>
                <div className="col-lg-6 mt-3">
                    <div className="form-group">
                        <label htmlFor="gender" className='pb-2 text-blue-gray-700 cm-xs-txt pb-2 fw-medium d-block'>{t("gender")} <span className='text-danger'>*</span></label>
                        <div className="position-relative">
                            <Select
                                labelId="genderLabel"
                                id="gender"
                                displayEmpty={true}
                                value={formVal.gender.value}
                                onChange={(e) => handleSelectChange(e, 'gender') }
                                fullWidth={true}
                                className="bg-white cm-sm-txt fw-medium text-blue-800 cm-select-field"
                                MenuProps={{
                                    className: "cm-select-modal"
                                }}
                            >
                                {loadSelectOptions("gender")}
                            </Select>
                            <FontAwesomeIcon icon={regular("chevron-down")} className="cm-select-arrow cm-sm-txt text-blue-800 position-absolute" />
                        </div>
                        {formVal.gender.msg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.gender.msg}</span>}
                        {formVal.gender?.value === "Other" && <div className="form-group mt-3">
                            <input type="text" className="form-control text-blue-800 fw-medium ps-3" id="firstName" value={formVal.gender?.inpVal} onChange={(e) => handleFieldChange(e, 'gender')} />
                            {formVal.gender.inpMsg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.gender.inpMsg}</span>}
                        </div>}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 mt-3">
                    <div className="form-group">
                        <label htmlFor="ethnicity" className='pb-2 text-blue-gray-700 cm-xs-txt pb-2 fw-medium d-block'>{t("ethnicity_race")} <span className='text-danger'>*</span></label>
                        <div className="position-relative">
                            <Select
                                labelId="ethnicityLabel"
                                id="ethnicity"
                                displayEmpty={true}
                                value={formVal.ethnicity.value}
                                onChange={(e) => handleSelectChange(e, 'ethnicity') }
                                fullWidth={true}
                                className="bg-white cm-sm-txt fw-medium text-blue-800 cm-select-field"
                                MenuProps={{
                                    className: "cm-select-modal"
                                }}
                            >
                                {loadSelectOptions("ethnicity")}
                            </Select>
                            <FontAwesomeIcon icon={regular("chevron-down")} className="cm-select-arrow cm-sm-txt text-blue-800 position-absolute" />
                        </div>
                        {formVal.ethnicity.msg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.ethnicity.msg}</span>}
                        {formVal.ethnicity?.value === "Other" && <div className="form-group mt-3">
                            <input type="text" className="form-control text-blue-800 fw-medium ps-3" id="firstName" value={formVal.ethnicity?.inpVal} onChange={(e) => handleFieldChange(e, 'ethnicity')} />
                            {formVal.ethnicity.inpMsg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.ethnicity.inpMsg}</span>}
                        </div>}
                    </div>
                </div>
                <div className="col-lg-6 mt-3">
                    <div className="form-group">
                        <label htmlFor="educationalBackground" className='pb-2 text-blue-gray-700 cm-xs-txt pb-2 fw-medium d-block'>{t("educational_background")} <span className='text-danger'>*</span></label>
                        <div className="position-relative">
                            <Select
                                labelId="educationalBackgroundLabel"
                                id="educationalBackground"
                                displayEmpty={true}
                                value={formVal.educationalBackground.value}
                                onChange={(e) => handleSelectChange(e, 'educationalBackground') }
                                fullWidth={true}
                                className="bg-white cm-sm-txt fw-medium text-blue-800 cm-select-field"
                                MenuProps={{
                                    className: "cm-select-modal"
                                }}
                            >
                                {loadSelectOptions("educationalBackground")}
                            </Select>
                            <FontAwesomeIcon icon={regular("chevron-down")} className="cm-select-arrow cm-sm-txt text-blue-800 position-absolute" />
                        </div>
                        {formVal.educationalBackground.msg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.educationalBackground.msg}</span>}
                        {formVal.educationalBackground?.value === "Other" && <div className="form-group mt-3">
                            <input type="text" className="form-control text-blue-800 fw-medium ps-3" id="firstName" value={formVal.educationalBackground?.inpVal} onChange={(e) => handleFieldChange(e, 'educationalBackground')} />
                            {formVal.educationalBackground.inpMsg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.educationalBackground.inpMsg}</span>}
                        </div>}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 mt-3">
                    <div className="form-group">
                        <label htmlFor="workExperience" className='pb-2 text-blue-gray-700 cm-xs-txt pb-2 fw-medium d-block'>{t("work_experience")} <span className='text-danger'>*</span></label>
                        <div className="position-relative">
                            <Select
                                labelId="workExperienceLabel"
                                id="workExperience"
                                displayEmpty={true}
                                value={formVal.workExperience.value}
                                onChange={(e) => handleSelectChange(e, 'workExperience') }
                                fullWidth={true}
                                className="bg-white cm-sm-txt fw-medium text-blue-800 cm-select-field"
                                MenuProps={{
                                    className: "cm-select-modal"
                                }}
                            >
                                {loadSelectOptions("workExperience")}
                            </Select>
                            <FontAwesomeIcon icon={regular("chevron-down")} className="cm-select-arrow cm-sm-txt text-blue-800 position-absolute" />
                        </div>
                        {formVal.workExperience.msg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.workExperience.msg}</span>}
                    </div>
                </div>
                <div className="col-lg-6 mt-3">
                    <div className="form-group">
                        <label htmlFor="location" className='pb-2 text-blue-gray-700 cm-xs-txt pb-2 fw-medium d-block'>{t("location")} <span className='text-danger'>*</span></label>
                        <div className="position-relative">
                            <Select
                                labelId="locationLabel"
                                id="location"
                                displayEmpty={true}
                                value={formVal.location.value}
                                onChange={(e) => handleSelectChange(e, 'location') }
                                fullWidth={true}
                                className="bg-white cm-sm-txt fw-medium text-blue-800 cm-select-field"
                                MenuProps={{
                                    className: "cm-select-modal"
                                }}
                            >
                                {loadSelectOptions("location")}
                            </Select>
                            <FontAwesomeIcon icon={regular("chevron-down")} className="cm-select-arrow cm-sm-txt text-blue-800 position-absolute" />
                        </div>
                        {formVal.location.msg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.location.msg}</span>}
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-6 mt-3">
                    <div className="form-group">
                        <label htmlFor="levelWithOrganization" className='pb-2 text-blue-gray-700 cm-xs-txt pb-2 fw-medium d-block'>{t("level_with_organization")} <span className='text-danger'>*</span></label>
                        <div className="position-relative">
                            <Select
                                labelId="levelWithOrganizationLabel"
                                id="levelWithOrganization"
                                displayEmpty={true}
                                value={formVal.levelWithOrganization.value}
                                onChange={(e) => handleSelectChange(e, 'levelWithOrganization') }
                                fullWidth={true}
                                className="bg-white cm-sm-txt fw-medium text-blue-800 cm-select-field"
                                MenuProps={{
                                    className: "cm-select-modal"
                                }}
                            >
                                {loadSelectOptions("levelWithOrganization")}
                            </Select>
                            <FontAwesomeIcon icon={regular("chevron-down")} className="cm-select-arrow cm-sm-txt text-blue-800 position-absolute" />
                        </div>
                        {formVal.levelWithOrganization.msg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.levelWithOrganization.msg}</span>}
                    </div>
                </div>
                <div className="col-lg-6 mt-3">
                    <div className="form-group">
                        <label htmlFor="jobFunction" className='pb-2 text-blue-gray-700 cm-xs-txt pb-2 fw-medium d-block'>{t("job_function")} <span className='text-danger'>*</span></label>
                        <div className="position-relative">
                            <Select
                                labelId="jobFunctionLabel"
                                id="jobFunction"
                                displayEmpty={true}
                                value={formVal.jobFunction.value}
                                onChange={(e) => handleSelectChange(e, 'jobFunction') }
                                fullWidth={true}
                                className="bg-white cm-sm-txt fw-medium text-blue-800 cm-select-field"
                                MenuProps={{
                                    className: "cm-select-modal"
                                }}
                            >
                                {loadSelectOptions("jobFunction")}
                            </Select>
                            <FontAwesomeIcon icon={regular("chevron-down")} className="cm-select-arrow cm-sm-txt text-blue-800 position-absolute" />
                        </div>
                        {formVal.jobFunction.msg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.jobFunction.msg}</span>}
                        {formVal.jobFunction?.value === "Other" && <div className="form-group mt-3">
                            <input type="text" className="form-control text-blue-800 fw-medium ps-3" id="firstName" value={formVal.jobFunction?.inpVal} onChange={(e) => handleFieldChange(e, 'jobFunction')} />
                            {formVal.jobFunction.inpMsg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.jobFunction.inpMsg}</span>}
                        </div>}
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-6 mt-3">
                    <div className="form-group">
                        <label htmlFor="industry" className='pb-2 text-blue-gray-700 cm-xs-txt pb-2 fw-medium d-block'>{t("industry")} <span className='text-danger'>*</span></label>
                        <div className="position-relative">
                            <Select
                                labelId="industryLabel"
                                id="industry"
                                displayEmpty={true}
                                value={formVal.industry.value}
                                onChange={(e) => handleSelectChange(e, 'industry') }
                                fullWidth={true}
                                className="bg-white cm-sm-txt fw-medium text-blue-800 cm-select-field"
                                MenuProps={{
                                    className: "cm-select-modal"
                                }}
                            >
                                {loadSelectOptions("industry")}
                            </Select>
                            <FontAwesomeIcon icon={regular("chevron-down")} className="cm-select-arrow cm-sm-txt text-blue-800 position-absolute" />
                        </div>
                        {formVal.industry.msg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.industry.msg}</span>}
                        {formVal.industry?.value === "Other" && <div className="form-group mt-3">
                            <input type="text" className="form-control text-blue-800 fw-medium ps-3" id="firstName" value={formVal.industry?.inpVal} onChange={(e) => handleFieldChange(e, 'industry')} />
                            {formVal.industry.inpMsg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.industry.inpMsg}</span>}
                        </div>}
                    </div>
                </div>
            </div>

            <div className="cm-form-btn-group d-flex align-items-center">
                <button onClick={handleFormSubmit} className={`cm-icon-btn mt-4 position-relative btn btn-primary cm-sm-txt cm-btn cm-prim-btn d-flex align-items-center ${isLoading ? 'cm-disable-btn' : ''}`}>
                    <span className="text-white">{t("save_changes")}</span>
                    <FontAwesomeIcon icon={regular('angle-right')} className="ps-2" />
                </button>
            </div>
        </form>
    )
}

export default PersonalDetailsForm;